import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * 表单勾选框组件 - 勾选/不勾选状态
 * checked 时 value 为 1，未勾选时 value 为 0
 */
const FormCheckbox = ({ label, checked, onChange, name }) => {
    return (
        <div className={styles.field}>
            <label className={`${styles.checkboxItem} ${checked ? styles.checkboxChecked : ''}`}>
                <input
                    type="checkbox"
                    name={name}
                    checked={checked}
                    onChange={e => onChange(e.target.checked ? 1 : 0)}
                    className={styles.checkboxInput}
                />
                <span className={styles.checkboxBox} />
                {label && <span className={styles.checkboxLabel}>{label}</span>}
            </label>
        </div>
    );
};

FormCheckbox.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
};

export default FormCheckbox;
